<template>
  <container-data-input-card
      :value="contact"
      :config="config"
      :blocked="block"
      is-single
      can-close-enter
      :saving="saving"
      :error="error"
      @change-data="saveContact($event)"
  >

  </container-data-input-card>
</template>

<script>
import ContainerDataInputCard from "@/components/cards/DataCardInput/ContainerDataInputCard";
import ContactsConfig from "@/pages/Contacts/configs/contacts";
import ContactsController from "@/controllers/ContactsController";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ContactMain",
  components: {ContainerDataInputCard},
  data() {
    return {
      contact: {
        typeContact: 'OTV'
      },
      saving: false,
      error: null,
      config: ContactsConfig
    }
  },
  computed: {
    block() {
      return false
    },
    ...mapGetters('checkFilled', {get_contact_data: 'get_contact_data'})
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions('checkFilled', {addNewContact: 'addNewContact'}),
    initData() {
      this.saving = true;
      const filler = this.get_contact_data?.find(el => el.typeContact === 'OTV')
      if (this.get_contact_data?.length && filler) {
        this.contact = {...this.contact, ...filler}
        this.saving = false;
        this.error = null;
        return;
      }
      ContactsController.getOrganizationContact()
          .then(data => {
            const filler = data.find(el => el.typeContact === 'OTV');
            if (filler)
            {
              this.addNewContact(filler);
              this.contact = {...this.contact, ...filler};
              this.error = null;
            }
          })
          .catch(() => this.error = 'Ошибка получения')
          .finally(() => this.saving = false)
    },
    saveContact(payload) {
      this.saving = true;
      ContactsController.setOrganizationContact(payload)
          .then(data => {
            this.addNewContact(data);
            this.contact = {...this.contact, ...data};
            this.error = null;
          })
          .catch(() => this.error = 'Ошибка сохранения')
          .finally(() => this.saving = false)
    }
  },
}
</script>

<style scoped>

</style>